import React, { useRef, useState, useEffect } from "react";
import {
  Paper,
  Modal,
  Box,
  TextField,
  Button,
  IconButton,
  Switch,
  FormControlLabel,
} from "@material-ui/core";
import { Typography, CardMedia, Grid, Stack, Avatar } from "@mui/material";
import PostAddRoundedIcon from "@mui/icons-material/PostAddRounded";
import Diversity3RoundedIcon from "@mui/icons-material/Diversity3Rounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "@mui/icons-material/Image";
import VideoCameraBackIcon from "@mui/icons-material/VideoCameraBack";
import DescriptionIcon from "@mui/icons-material/Description";
import "../../../../Assets/css/Community/MyfeedInfo.css";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import BackupOutlinedIcon from "@mui/icons-material/BackupOutlined";
import { useDispatch } from "react-redux";
import {
  getFeeds,
  getMyFeeds,
  postFeed,
  updateFeed,
} from "../../../../Redux/Reducers/communityReducer";
import { useSelector } from "react-redux";
import { useUserDetailContext } from "Components/UserDetailContext";


const PostFeedModal = ({
  open,
  onClose,
  initialContent = "",
  initialMedia = [],
  onSubmit,
  postId = null,
  isEditMode = false,
}) => {
  const [isPublic, setIsPublic] = useState(true);
  const [postContent, setPostContent] = useState(initialContent);
  const [files, setFiles] = useState(initialMedia);
  const fileInputRef = useRef(null);
  const [currentImgIdx, setCurrentImgIdx] = useState(0);
  const dispatch = useDispatch();
  const ProfessionalData = useSelector(
    (state) => state?.ProfileArray?.professionaProfile
  );
  const { userDetails } = useUserDetailContext();
  const userName =
    userDetails?.firstName + " " + userDetails?.lastName || "User";

  console.log("initialMedia", initialMedia);

  // Handle file upload
  const handleFileUpload = (e) => {
    const newFiles = Array.from(e.target.files);

    const processedFiles = newFiles.map((file) => {
      if (file.type === "application/pdf") {
        return {
          file,
          type: "pdf",
          preview: URL.createObjectURL(file),
        };
      }
      return {
        file,
        type: file.type.split("/")[0],
        preview: URL.createObjectURL(file),
      };
    });

    setFiles((prevFiles) => {
      const updatedFiles = [...prevFiles, ...processedFiles];
      // If no image is selected, set to first image
      if (updatedFiles.length > 0 && currentImgIdx === 0) {
        setCurrentImgIdx(0);
      }
      return updatedFiles;
    });
    e.target.value = null;
  };

  // Remove file from preview
  const removeFile = (index) => {
    const newFiles = [...files];
    URL.revokeObjectURL(newFiles[index].preview);
    newFiles.splice(index, 1);
    setFiles(newFiles);
    if (currentImgIdx >= newFiles.length) {
      setCurrentImgIdx(Math.max(0, newFiles.length - 1));
    }
  };

  // Cleanup object URLs on unmount
  useEffect(() => {
    return () => {
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    };
  }, []);

  useEffect(() => {
    if (isEditMode && initialMedia.length > 0) {
      const processedMedia = initialMedia.map((mediaItem) => ({
        file: null, // No file object for existing media
        type: mediaItem.type.startsWith("image")
          ? "image"
          : mediaItem.type.startsWith("video")
          ? "video"
          : mediaItem.type === "application/pdf"
          ? "pdf"
          : "unknown", // Normalize type
        preview: mediaItem.url, // Use the URL for preview
      }));
      setFiles(processedMedia);
    }
  }, [isEditMode, initialMedia]);

  // console.log("initialMedia", initialMedia);

  const handleSubmit = async () => {
    const payload = new FormData();

    // Add post content and visibility
    payload.append("content", postContent);
    payload.append("is_visible", isPublic.toString());
    payload.append("post_category", "PROFESSIONAL");

    // Add media files and existing media URLs as binary
    for (const f of files) {
      if (f.file) {
        // Append new files
        payload.append("media", f.file);
      } else if (f.preview) {
        // Convert URL to binary and append
        try {
          const response = await fetch(f.preview);
          const blob = await response.blob();
          payload.append("media", blob, `existing-media-${Date.now()}`);
        } catch (error) {
          console.error("Failed to fetch media URL:", error);
        }
      }
    }

    console.log("Payload:", payload);

    try {
      if (isEditMode) {
        const updatePayload = {
          id: postId, // Assuming `postId` is available
          data: payload,
        };
        await dispatch(updateFeed(updatePayload));
        await dispatch(getMyFeeds({ type: "PROFESSIONAL" }));
        await dispatch(getFeeds({ type: "PROFESSIONAL", my_posts: false }));
      } else {
        await dispatch(postFeed(payload));
        await dispatch(getMyFeeds({ type: "PROFESSIONAL" }));
        await dispatch(getFeeds({ type: "PROFESSIONAL", my_posts: false }));
      }
      onClose();
    } catch (error) {
      console.error(
        isEditMode ? "Update failed:" : "Post submission failed:",
        error
      );
    }
  };

  // Trigger file input
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleThumbnailClick = (index) => {
    setCurrentImgIdx(index);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="post-modal-container">
        <div className="post-modal-heading">
          <h6>{isEditMode ? "Edit Post" : "Create Post"}</h6>
        </div>
        <div className="modal-content-container">
          {/* Left side - Media preview (50%) */}
          <div className="media-preview-section">
            {files?.length > 0 ? (
              <>
                {/* Hero preview */}
                <div className="hero-preview">
                  {files[currentImgIdx].type === "image" && (
                    <img
                      src={files[currentImgIdx].preview}
                      alt="preview"
                      width={"100%"}
                      className="preview-image-hero"
                    />
                  )}
                  {files[currentImgIdx].type == "video/mp4" && (
                    <video className="preview-video-hero" controls>
                      <source
                        src={files[currentImgIdx].preview}
                        type={files[currentImgIdx].file?.type || "video/mp4"}
                      />
                      Your browser does not support the video tag.
                    </video>
                  )}
                  {files[currentImgIdx].type === "pdf" && (
                    <div className="pdf-preview-hero">
                      <embed
                        src={files[currentImgIdx].preview}
                        type="application/pdf"
                        width="100%"
                        height="300px"
                      />
                      <span className="file-name-hero">
                        {files[currentImgIdx].file.name}
                      </span>
                    </div>
                  )}
                </div>

                {/* Thumbnails row */}
                <Grid
                  container
                  spacing={1}
                  wrap="nowrap"
                  sx={{ overflowX: "auto", mt: 1 }}
                >
                  {files?.map((f, idx) => (
                    <Grid item key={idx} position={"relative"}>
                      <div
                        className={`thumbnail-item ${
                          idx === currentImgIdx ? "selected" : ""
                        }`}
                        onClick={() => handleThumbnailClick(idx)}
                      >
                        <IconButton
                          className="remove-thumbnail"
                          onClick={(e) => {
                            e.stopPropagation();
                            removeFile(idx);
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                        {f.type === "image" && (
                          <img
                            src={f.preview}
                            alt={`thumb-${idx}`}
                            className="thumbnail-image"
                          />
                        )}
                        {f.type === "video/mp4" && (
                          <div className="thumbnail-video">
                            <VideoCameraBackIcon />
                          </div>
                        )}
                        {f.type === "pdf" && (
                          <div className="thumbnail-pdf">
                            <DescriptionIcon />
                          </div>
                        )}
                      </div>
                    </Grid>
                  ))}

                  {/* "Add media" button */}
                  <Grid item>
                    <div className="attachment-buttons">
                      <input
                        ref={fileInputRef}
                        accept="image/*,video/*,application/pdf"
                        style={{ display: "none" }}
                        type="file"
                        multiple
                        onChange={handleFileUpload}
                      />
                      <Button
                        onClick={triggerFileInput}
                        className="add-media-btn"
                        variant="outlined"
                      >
                        <AddPhotoAlternateOutlinedIcon />
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </>
            ) : (
              /* When no files */
              <div className="empty-preview" onClick={triggerFileInput}>
                <input
                  ref={fileInputRef}
                  accept="image/*,video/*,application/pdf"
                  style={{ display: "none" }}
                  type="file"
                  multiple
                  onChange={handleFileUpload}
                />
                {/* <Button
                  onClick={triggerFileInput}
                  className="add-media-btn-large"
                  // variant="outlined"
                > */}
                <BackupOutlinedIcon sx={{ fontSize: 120 }} />
                {/* </Button> */}
                <Typography>Upload media</Typography>
              </div>
            )}
          </div>

          {/* Right side - Text input (50%) */}
          <div className="text-input-section">
            <div className="post-modal-user">
              <div>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Avatar src={ProfessionalData?.user_profile_url} />
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {userName}
                      </Typography>
                    </Box>
                  </Box>
                </Stack>
              </div>

              <div className="post-modal-header">
                <IconButton onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </div>
            </div>
            <TextField
              className="post-input"
              placeholder="What's on your mind...?"
              multiline
              minRows={10}
              variant="outlined"
              fullWidth
              value={postContent}
              onChange={(e) => setPostContent(e.target.value)}
            />
            <div className="post-button-container">
              <div className="privacy-setting">
                <FormControlLabel
                  control={
                    <Switch
                      checked={isPublic}
                      onChange={(e) => setIsPublic(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={isPublic ? "Public" : "Private"}
                  labelPlacement="start"
                />
              </div>
              <Button
                className="post-button"
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={!postContent.trim() && files.length === 0}
              >
                {isEditMode ? "Update" : "Post"}
              </Button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default PostFeedModal;
